import React from 'react';

import { Title } from '../../../../../components/title/title';
import { Translate } from '../../../../../components/translate';
import { Quote } from './quote';
import './quotes.scss';

type QuotesProps = {};

export const Quotes: React.FC<QuotesProps> = () => (
  <div className="rc-growth-quotes-wrapper">
    <Title level="4" weight="bold">
      <Translate id="translate.growth.card.quotes.title" />
    </Title>

    <div className="rc-growth-quotes">
      <Quote color="light-purple">
        <Translate id="translate.growth.quotes.text.one" />
      </Quote>

      <Quote color="dark-purple">
        <Translate id="translate.growth.quotes.text.two" />
      </Quote>
    </div>

    <div className="rc-growth-quotes rc-growth-quotes-reversed">
      <Quote color="orange">
        <Translate id="translate.growth.quotes.text.three" />
      </Quote>

      <Quote color="blue">
        <Translate id="translate.growth.quotes.text.four" />
      </Quote>
    </div>

    <div className="rc-growth-quotes">
      <Quote color="dark-purple">
        <Translate id="translate.growth.quotes.text.five" />
      </Quote>

      <Quote color="light-purple">
        <Translate id="translate.growth.quotes.text.six" />
      </Quote>
    </div>
  </div>
);
